import { depascalize, DropdownOption, getEnumValues } from "sprint-common-web";

export enum DeliveryBucketAccessType {
    Key = 1,
    Role = 2
}

export const deliveryBucketAccessTypeDropdownOptions = getEnumValues(DeliveryBucketAccessType).map(
    (type: DeliveryBucketAccessType): DropdownOption => ({
        key: type.toString(),
        text: depascalize(DeliveryBucketAccessType[type])
    })
);
